import {
  MSG_DELETE_WARNING,
  MSG_UNDO_DELETE_WARNING,
  MSG_RECORD_CREATE,
  MSG_RECORD_UPDATE,
  MSG_RECORD_DELETE,
  MSG_RECORD_UNDO,
  MIN_TEXT_LENGTH,
  MAX_TEXT_LENGTH,
} from "constants/common";

//VSP 360 Version
export const METHOD_VSP_360_VERSION_LIST = "vsp360version/pageable/"; //check with backend team
export const METHOD_VSP_360_VERSION_CREATE = "vsp360version/";
export const METHOD_VSP_360_VERSION_UPDATE = "vsp360version/{ID}/";
export const METHOD_VSP_360_VERSION_DELETE = "vsp360version/{ID}/";
export const METHOD_VSP_360_VERSION_DETAIL = "vsp360version/{ID}/";


//VSP 360 VSP_360_SERVICES
export const METHOD_VSP_360_SERVICES_LIST = "vsp360services/pageable/";
export const METHOD_VSP_360_SERVICES_CREATE = "vsp360services/";
export const METHOD_VSP_360_SERVICES_UPDATE = "vsp360services/{ID}/";
export const METHOD_VSP_360_SERVICES_DELETE = "vsp360services/{ID}/";
export const METHOD_VSP_360_SERVICES_DETAIL = "vsp360services/{ID}/";


//text box length
export const TEXT_MIN_LENGTH = MIN_TEXT_LENGTH;
export const TEXT_MAX_LENGTH = MAX_TEXT_LENGTH;

//language constants
export const MSG_WARNING_DELETE = MSG_DELETE_WARNING;
export const MSG_WARNING_UNDO_DELETE = MSG_UNDO_DELETE_WARNING;
export const MSG_CREATE_RECORD = MSG_RECORD_CREATE;
export const MSG_UPDATE_RECORD = MSG_RECORD_UPDATE;
export const MSG_DELETE_RECORD = MSG_RECORD_DELETE;
export const MSG_UNDO_RECORD = MSG_RECORD_UNDO;

// generic error template

export const MSG_COMBINE_KEY_WARNING =
  "Please select at least one combine key from the dropdown!";
export const MSG_MAPPING_DELETE_WARNING = "Are you sure you want to remove ";
export const MSG_MAPPING_RESTORE_WARNING = "Are you sure you want to restore ";
export const MAPPING_SELECT_ERROR_TEMPLATE = "Please select _FIELD_NAME_!";
export const MAPPING_INPUT_ERROR_TEMPLATE = "Please enter _FIELD_NAME_!";